import React, { Component } from 'react';
import get from 'lodash/get';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { withRouter, browserHistory } from 'react-router';

import { setPassword } from '../../../../actions/userActions';
import { trimUserInput } from '../../../../utils/formHelpers';

import '../style.css';

const validate = formProps => {
  const errors = {};

  if (!formProps.password) {
    errors.password = 'Password is required';
  } else if (formProps.password.length < 4) {
    errors.password = 'Must be 4 characters or more';
  } else if (formProps.password !== formProps.cfmPassword) {
    errors.cfmPassword = 'Password does not match';
  }

  return errors;
};

const renderField = ({
  input,
  label,
  type,
  disabled,
  meta: { touched, error, warning }
}) => {
  let hasStatus = null;
  let message = null;

  // remove touched from first two tests to
  // force form validation on initial load
  if (touched && error) {
    hasStatus = 'danger';
    message = error;
  } else if (touched && warning) {
    hasStatus = 'warning';
    message = warning;
  } else if (touched) {
    hasStatus = 'success';
    message = null;
  } else {
    hasStatus = null;
    message = null;
  }

  return (
    <div className={`form-group ${hasStatus ? 'has-' + hasStatus : ''}`}>
      {/* <label className="col-form-label col-sm-3 text-sm-right pr-0" htmlFor={input.name}>
        {label}
      </label> */}

      <div className={`input-wrapper rounded  ${hasStatus ? 'has-' + hasStatus : ''}`}>
        <div className="text-left px-4">
          <small>{label}</small>
        </div>
        <input
          id={input.name}
          className="form-control form-control-danger form-control-warning form-control-success border-0 px-4"
          {...input}
          disabled={disabled}
          type={type}
        />
      </div>
      {message ? (
        <div className="form-control-feedback">
          <small>{message}</small>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

class ResetPasswordForm extends Component {
  handleFormSubmit = (values) => {
    // clean up any user input
    const userInput = trimUserInput(values);

    // pick off the values we want
    const { password } = userInput;
    const token = get(this.props.location, 'query.token');

    return new Promise((resolve, reject) => {
      this.props.setPassword(
        password,
        token,
        () => {
          browserHistory.replace('/login');
          resolve();
        },
        error => {
          reject(error);
        }
      );
    }).catch(ex => {
      throw new SubmissionError(ex);
    });
  }

  render() {
    const {
      error, handleSubmit, pristine, submitting
    } = this.props;

    return (
      <form
        className="AuthForm ResetPasswordForm form"
        onSubmit={handleSubmit(this.handleFormSubmit)}
      >
        <Field
          name="password"
          component={renderField}
          type="password"
          label="Password"
          placeholder="Password"
        />

        <Field
          name="cfmPassword"
          component={renderField}
          type="password"
          label="Password confirmation"
          placeholder="Password"
        />

        <button
          type="submit"
          className="btn btn-primary btn-lg btn-cursor w-100"
          disabled={pristine || submitting}
        >
          Reset my password
        </button>

        {// if an error exists, render an Alert
          error && <p className="text-danger my-2">{error}</p>
        }
      </form>
    );
  }
}

export default compose(
  withRouter,
  connect(null, { setPassword }),
  reduxForm({ form: 'resetPasswordForm', validate })
)(ResetPasswordForm);



// WEBPACK FOOTER //
// ./src/components/forms/Auth/ResetPasswordForm/index.js